// import  './default/index.scss' // 默认
// import './NewYear/index.scss'  //2022新年
//import './spring/index.scss' //2022春天
import './year/index.scss' // 全年

const defaultSkinName = 'year'

export const taskHeadTitle = require('@/skin/' + defaultSkinName + '/task/task_head.png')

export const taskHeadPhoto = require('@/skin/' + defaultSkinName + '/task/task_head_photo.png')
export const taskHeadFile = require('@/skin/' + defaultSkinName + '/task/task_head_file.png')
export const taskHeadVideo = require('@/skin/' + defaultSkinName + '/task/task_head_video.png')
export const taskHeadMusic = require('@/skin/' + defaultSkinName + '/task/task_head_music.png')

export const boxPhoto = require('@/skin/' + defaultSkinName + '/task/box_photo.png')
export const boxFile = require('@/skin/' + defaultSkinName + '/task/box_file.png')
export const boxVideo = require('@/skin/' + defaultSkinName + '/task/box_video.png')
export const boxMusic = require('@/skin/' + defaultSkinName + '/task/box_music.png')

export const makeWishBtn = require('@/skin/' + defaultSkinName + '/page/make_wish_btn.png')
export const prizeBtn = require('@/skin/' + defaultSkinName + '/page/prize.png')
export const roleBtn = require('@/skin/' + defaultSkinName + '/page/role.png')

export const wishAlter = require('@/skin/' + defaultSkinName + '/page/wish_alter.png')
export const boxEnd = require('@/skin/' + defaultSkinName + '/page/box_end.png')
export const Photo = require('@/skin/' + defaultSkinName + '/task/Photo.png')
export const File = require('@/skin/' + defaultSkinName + '/task/File.png')
export const Video = require('@/skin/' + defaultSkinName + '/task/Video.png')
export const Music = require('@/skin/' + defaultSkinName + '/task/Music.png')
export const mayPrizeTitle = require('@/skin/' + defaultSkinName + '/page/may_prize_title.png')
